<template>
  <div>
    <span>Paramètres</span>
  </div>
</template>

<script>
export default {
  name: "Params"
}
</script>

<style scoped>

</style>